import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Store, Trash2, Boxes, IndianRupee } from "lucide-react";
import { api, apiErr, inr } from "@/lib/api";

export default function AdminStores() {
  const [stores, setStores] = useState([]);
  const [f, setF] = useState({ name: "", city: "", address: "", phone: "" });
  const load = () => api.get("/admin/stores").then((r) => setStores(r.data));
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!f.name) return toast.error("Store name required");
    try { await api.post("/admin/stores", { ...f, active: true }); toast.success("Store added"); setF({ name: "", city: "", address: "", phone: "" }); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => { if (!window.confirm("Delete this store & its stock?")) return; try { await api.delete(`/admin/stores/${id}`); load(); } catch (e) { toast.error(apiErr(e)); } };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between"><h1 className="text-2xl font-bold">Stores / Branches</h1></div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {stores.map((s) => (
          <div key={s.id} data-testid={`store-${s.id}`} className="bg-white rounded-xl border border-slate-200 p-5">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-2"><div className="w-9 h-9 bg-emerald-100 text-emerald-700 rounded-lg flex items-center justify-center"><Store size={18} /></div><div><p className="font-bold text-sm leading-tight">{s.name}</p><p className="text-xs text-slate-400">{s.city}</p></div></div>
              {s.id !== "store_main" && <button data-testid={`del-store-${s.id}`} onClick={() => del(s.id)} className="text-slate-400 hover:text-red-500"><Trash2 size={15} /></button>}
            </div>
            <div className="grid grid-cols-3 gap-2 mt-4 text-center">
              <div><p className="text-lg font-extrabold flex items-center justify-center gap-0.5"><Boxes size={13} className="text-slate-400" />{s.stock_units}</p><p className="text-[10px] text-slate-500">Stock</p></div>
              <div><p className="text-lg font-extrabold">{s.sku_count}</p><p className="text-[10px] text-slate-500">SKUs</p></div>
              <div><p className="text-lg font-extrabold text-emerald-600">{inr(s.sales)}</p><p className="text-[10px] text-slate-500">Sales</p></div>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-5 max-w-lg">
        <h2 className="font-bold mb-3">Add New Branch</h2>
        <div className="grid grid-cols-2 gap-2">
          <input data-testid="store-name" placeholder="Store name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="border border-slate-300 rounded-lg px-3 py-2 text-sm col-span-2" />
          <input data-testid="store-city" placeholder="City" value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className="border border-slate-300 rounded-lg px-3 py-2 text-sm" />
          <input data-testid="store-phone" placeholder="Phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="border border-slate-300 rounded-lg px-3 py-2 text-sm" />
          <input data-testid="store-address" placeholder="Address" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} className="border border-slate-300 rounded-lg px-3 py-2 text-sm col-span-2" />
          <button data-testid="add-store-btn" onClick={add} className="col-span-2 bg-emerald-600 text-white rounded-lg py-2 font-bold text-sm flex items-center justify-center gap-1"><Plus size={15} /> Add Store</button>
        </div>
        <p className="text-xs text-slate-400 mt-2">New branches start with independent (empty) stock — adjust it from the Inventory page using the store selector.</p>
      </div>
    </div>
  );
}
